module.exports = __webpack_public_path__ + "img/logo.49808a03.png";